import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { get_dialogPageNavigator3pxggbj34kkoa as get_dialogPageNavigator } from '../../navigation/Navigator.mjs';
import { Companion_instance15pczmasjuxgh as Companion_instance } from './ContainingView.commonHtml.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { DismissSemantic_getInstancerntwsmxwx5kd as DismissSemantic_getInstance } from '../../models/Theme.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = $this.ebn_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var tmp = $this.fbn_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function DismissBackground$addChild$lambda(it) {
  it.stopImmediatePropagation();
  return Unit_instance;
}
var DismissBackground$onClick$lambda$slambdaClass;
function DismissBackground$onClick$lambda$slambda() {
  if (DismissBackground$onClick$lambda$slambdaClass === VOID) {
    class $ {
      constructor($action) {
        this.ebn_1 = $action;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DismissBackground$onClick$lambda$slambdaClass = $;
  }
  return DismissBackground$onClick$lambda$slambdaClass;
}
function DismissBackground$onClick$lambda$slambda_0($action) {
  var i = new (DismissBackground$onClick$lambda$slambda())($action);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var DismissBackground$onClick$lambda$slambdaClass_0;
function DismissBackground$onClick$lambda$slambda_1() {
  if (DismissBackground$onClick$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($action) {
        this.fbn_1 = $action;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DismissBackground$onClick$lambda$slambdaClass_0 = $;
  }
  return DismissBackground$onClick$lambda$slambdaClass_0;
}
function DismissBackground$onClick$lambda$slambda_2($action) {
  var i = new (DismissBackground$onClick$lambda$slambda_1())($action);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var DismissBackgroundClass;
function DismissBackground() {
  if (DismissBackgroundClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.vb5_1.zb3_1 = 'div';
        this.vb5_1.jb4_1.v('kiteui-stack');
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.replaceEventListener' call
        var this_0 = this.vb5_1;
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp0_safe_receiver['on' + 'click'] = (it) => {
            get_dialogPageNavigator(this).v3();
            return Unit_instance;
          };
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = 'on' + 'click';
          this_0.gb4_1[tmp_0] = (it) => {
            get_dialogPageNavigator(this).v3();
            return Unit_instance;
          };
        }
      }
      wb9(index, view) {
        super.wb9(index, view);
        Companion_instance.nbg(this, index, view);
      }
      tba(view) {
        super.tba(view);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = view.vb5_1;
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('click', DismissBackground$addChild$lambda);
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.gb4_1['on' + 'click'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'click';
          this_0.gb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            it.stopImmediatePropagation();
            return Unit_instance;
          };
        }
      }
      vbo(action) {
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.replaceEventListener' call
        var this_0 = this.vb5_1;
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp0_safe_receiver['on' + 'click'] = (it) => {
            launch(this, VOID, VOID, DismissBackground$onClick$lambda$slambda_0(action));
            return Unit_instance;
          };
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = 'on' + 'click';
          this_0.gb4_1[tmp_0] = (it) => {
            launch(this, VOID, VOID, DismissBackground$onClick$lambda$slambda_2(action));
            return Unit_instance;
          };
        }
      }
      nba(theme) {
        return super.nba(theme.fb1(DismissSemantic_getInstance()));
      }
    }
    initMetadataForClass($, 'DismissBackground');
    DismissBackgroundClass = $;
  }
  return DismissBackgroundClass;
}
//region block: exports
export {
  DismissBackground as DismissBackground1nezyx9ss0e1b,
};
//endregion

//# sourceMappingURL=DismissBackground.commonHtml.mjs.map
